import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, TextField, Tooltip, Typography, Button, Grid } from "@mui/material";
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingIndicator } from "../../../components/loading-indicator.component";
import { useAuthorize } from "../../../hooks/use-authorize";
import { UserPermissionName } from "../../../models/user-permission-name";
import { useState } from "react";
import { ReactHookForm } from "../../../components/hook-form/react-hook-form.component";
import { useReactHookForm } from "../../../hooks/useReactHookForm";
import { workOrdersApiKeyStore } from "../../../api/workorders-api-key-store";
import FormInput from "../../query-builder/hooks-form-querybuilder/form-input.component";
import { FormAutoCompleteSelectDynamic } from "../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";

const invoiceAmountValidationSchema = Yup.object().shape({
    changeReason: Yup.object()
        .shape({
            changeReasonID: Yup.string()
                .nullable()
                .required('Select reason is required')
                .test('not-zero', 'Select reason is required', (value: any) => value !== '' && value !== 0),
        })
        .required('Select reason  is required'),
});

const reasonDescriptinValidationSchema = Yup.object().shape({
    reasonDescription: Yup.string().required('Reason description is required'),
    changeReason: Yup.object()
        .shape({
            changeReasonID: Yup.string()
                .nullable()
                .required('Select reason is required')
                .test('not-zero', 'Select reason is required', (value: any) => value !== '' && value !== 0),
        })
        .required('Select reason  is required'),
});

interface InvoiceAmountUpdateReasonDialog {
    isOpenReason: boolean;
    isLoading: boolean;
    reasonType: string;
    saveReason: (reason: any) => void;
    closedDialogReason: () => void;
}

export const InvoiceAmountUpdateReasonDialog = ({ isOpenReason, isLoading, reasonType, saveReason, closedDialogReason }: InvoiceAmountUpdateReasonDialog) => {

    const [isReasonEnable, setReasonEnable] = useState<boolean>(true);
    const [reasonName, setReasonName] = useState<any>();

    const form = useReactHookForm({
        defaultValues: {
            changeReason: null,
            reasonDescription: ""
        },
        yupSchema: reasonName !== "Other" ? invoiceAmountValidationSchema : reasonDescriptinValidationSchema
    });

    const handleSubmit = async (dataValue: any) => {
        const { changeReason, ...otherValue } = dataValue;
        const payload = { ...otherValue, changeReasonID: changeReason?.changeReasonID, reasonType: reasonType }
        saveReason(payload);
    };

    const handleReasonChange = (reasonValue: any) => {
        form.setValue("changeReason", reasonValue, { shouldValidate: true });
        setReasonName(reasonValue?.reasonName);

        if (reasonValue?.reasonName === "Other") {
            setReasonEnable(false);
            form.setValue("reasonDescription", "", { shouldValidate: true });
        } else {
            setReasonEnable(true);
            form.setValue(
                "reasonDescription",
                reasonValue?.reasonDescription || "",
                { shouldValidate: true }
            );
        }
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={isOpenReason}
            className="modalpopup"
            title={'REASON'}
            // onClose={closedDialogReason}
            maxWidth={'md'}
            fullWidth={true}
        >
            <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
                Reason
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={closedDialogReason}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 3,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <LoadingIndicator isLoading={isLoading} />
            <DialogContent>
                <ReactHookForm formName="WORK_ORDER_REASON_FORM" onSubmit={handleSubmit} formContextProps={form}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <FormAutoCompleteSelectDynamic
                                name="changeReason"
                                label="Select a reason"
                                onChange={handleReasonChange}
                                getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderReasons()}
                                optionsValueKey="changeReasonID"
                                optionsLabelKey="reasonName"
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <FormInput name="reasonDescription" label="Description" multiline size={3.5} disabled={isReasonEnable} />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <div className="spaceBetween">
                                <Button variant="outlined" style={{ width: '130px' }} onClick={closedDialogReason}>
                                    Cancel
                                </Button>
                                <Button
                                    type='submit' variant="contained" style={{ width: '130px' }}
                                    disabled={isLoading || isReadOnlyPermission}
                                >
                                    Save
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </ReactHookForm>
            </DialogContent>
        </Dialog>
    );
}